import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TTSVoice } from '../../types';
import { saveFavorites } from '../../services/favorites';

interface VoicesState {
  voices: TTSVoice[];
  selectedVoice: TTSVoice | null;
  favorites: string[];
  loading: boolean;
  error: string | null;
}

const initialState: VoicesState = {
  voices: [],
  selectedVoice: null,
  favorites: [],
  loading: false,
  error: null,
};

const voicesSlice = createSlice({
  name: 'voices',
  initialState,
  reducers: {
    setVoices: (state, action: PayloadAction<TTSVoice[]>) => {
      state.voices = action.payload;
      state.loading = false;
      state.error = null;
    },
    setSelectedVoice: (state, action: PayloadAction<TTSVoice | null>) => {
      state.selectedVoice = action.payload;
    },
    setFavorites: (state, action: PayloadAction<string[]>) => {
      state.favorites = action.payload;
    },
    addToFavorites: (state, action: PayloadAction<{ voiceId: string; userId: string }>) => {
      if (!state.favorites.includes(action.payload.voiceId)) {
        state.favorites = [...state.favorites, action.payload.voiceId];
        saveFavorites(action.payload.userId, state.favorites).catch((error) => {
          console.error('Failed to save favorites:', error);
          state.favorites = state.favorites.filter(id => id !== action.payload.voiceId);
        });
      }
    },
    removeFromFavorites: (state, action: PayloadAction<{ voiceId: string; userId: string }>) => {
      const newFavorites = state.favorites.filter(id => id !== action.payload.voiceId);
      saveFavorites(action.payload.userId, newFavorites).catch((error) => {
        console.error('Failed to save favorites:', error);
        return;
      });
      state.favorites = newFavorites;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setVoices,
  setSelectedVoice,
  setFavorites,
  addToFavorites,
  removeFromFavorites,
  setLoading,
  setError,
} = voicesSlice.actions;

export default voicesSlice.reducer;